import React, { useState } from "react";
import { toast } from "sonner";
import { http } from "../lib/api";
import { Mail, ArrowRight, Loader2 } from "lucide-react";

export const SubscribeBar = ({ variant = "light" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const dark = variant === "dark";

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) { toast.error("Enter a valid email"); return; }
    setLoading(true);
    try {
      await http.post("/subscribers", { email });
      toast.success("You're on the list. The next report will land in your inbox.");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="subscribe-bar" className={`${dark ? "bg-[#2C5F3A]" : "bg-[#FAF8F1] border border-[#16281C]/12"} p-7 md:p-10`}>
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
        <div className="max-w-lg">
          <div className={`inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] uppercase ${dark ? "text-[#EFEBDE]/70" : "text-[#2C5F3A]"}`}>
            <Mail size={13} /> Newsletter
          </div>
          <h3 className={`mt-3 font-display font-semibold text-2xl md:text-3xl tracking-tight ${dark ? "text-[#EFEBDE]" : "text-[#16281C]"}`}>
            Get the next report in your inbox.
          </h3>
        </div>
        <form onSubmit={submit} className="flex w-full lg:w-auto gap-3">
          <input
            data-testid="subscribe-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            className={`flex-1 lg:w-72 px-5 py-4 font-body text-[15px] rounded-none focus:outline-none transition-colors ${dark ? "bg-[#EFEBDE] text-[#16281C] placeholder:text-[#8B978C] border border-transparent focus:border-[#EFEBDE]" : "bg-[#EFEBDE] text-[#16281C] placeholder:text-[#8B978C] border border-[#16281C]/15 focus:border-[#2C5F3A]"}`}
          />
          <button
            type="submit"
            data-testid="subscribe-button"
            disabled={loading}
            className={`inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase px-6 py-4 transition-colors disabled:opacity-60 ${dark ? "bg-[#EFEBDE] text-[#16281C] hover:bg-white" : "bg-[#2C5F3A] text-[#EFEBDE] hover:bg-[#367A49]"}`}
          >
            {loading ? <Loader2 size={15} className="animate-spin" /> : <>Subscribe <ArrowRight size={15} /></>}
          </button>
        </form>
      </div>
    </div>
  );
};
